const getters = {
    sidebar: state => state.app.sidebar,
    token:(state)=> state.user.token,
    countryList:state=>state.user.countryList,
    userInfo:state=>state.user.userInfo
    //token: () => 'a67d338e-a5be-4740-82f1-a7cc9b305225'
}
export default getters;
